import {CustomHeader} from "datastage/components/AGGrid/cell-renderers/custom-header.jsx";
import Moment from 'moment';

export const productId = {
    field: 'productId',
    headerName: 'Product ID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productId',
        page: 'readyProducts',
    },
    minWidth: 100,
};

export const productTitle = {
    field: 'productTitle',
    headerName: 'Title Name',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productTitle',
        page: 'readyProducts',
    },
    minWidth: 200,
};

export const releaseDate = {
    field: 'releaseDate',
    headerName: 'Release Date',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'releaseDate',
        page: 'readyProducts',
    },
    minWidth: 100,
    valueFormatter: params => params.value ? Moment(params.value).format('MM/DD/YYYY') : '',
};

export const productClass = {
    field: 'productClass',
    headerName: 'Type',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'productClass',
        page: 'readyProducts',
    },
    minWidth: 100,
};